import { IDiscount } from '@jumpstart/core';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Theme } from '@mui/material/styles';
import { FieldArray, Form, Formik } from 'formik';
import React, { useState } from 'react';
import { array, number, object, string } from 'yup';

const inputStyles = {
  // backgroundColor: theme.palette.primary.contrastText
  color: (theme: Theme) => theme.palette.primary.contrastText
  // width: 320,
};

export interface IOrderDiscountsView {
  onAdd(discounts: IDiscount[]): void;
}

const discountSchema = object({
  discounts: array().of(object().shape({ rate: number().max(100).min(0), label: string() }))
});

export default function InvoiceDiscountsView(props: IOrderDiscountsView) {
  const { onAdd } = props;
  const [adding, setAdding] = useState(false);

  return (
    <Grid container direction="column">
      <Collapse in={!adding}>
        <Button color="secondary" onClick={() => setAdding(true)}>Apply Discounts</Button>
      </Collapse>
      <Collapse in={adding}>

        <Formik
          initialValues={{
            discounts: []
          }}
          onSubmit={values => {
            setAdding(false);
            onAdd(values.discounts.map((d: { label: string; rate: string }) => {
              return {
                label: d.label,
                rate: parseInt(d.rate) / 100
              };
            }));
          }}
          validationSchema={discountSchema}
        >
          {
            ({ values, setFieldValue, handleChange, submitCount, errors, touched }) => (
              <Form>
                <Grid
                  container
                  direction="column"
                  sx={{
                    '& > *': {
                      marginBottom: 4
                    }
                  }}
                >

                  <FieldArray
                    name="discounts"
                  >
                    {(discountsArrayHelpers) => (<Grid container direction="column">
                        {values.discounts.map((discount: { label: string; rate: number }, index: number) =>
                          <Grid container direction="row" key={`discount-${index}`} wrap="nowrap" alignItems="center">
                            <Grid item xs={8}>

                              <FormControl
                                sx={inputStyles}
                                variant="outlined"
                              >
                                <OutlinedInput
                                  id={`discounts[${index}].label`}
                                  name={`discounts[${index}].label`}
                                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    console.log(event.target.value);
                                    setFieldValue(`discounts[${index}].label`, event.target.value);
                                  }}
                                  // className={classes.input}
                                  placeholder="Discount Label"
                                />
                              </FormControl>
                              <FormControl
                                sx={inputStyles}
                                variant="outlined"
                              >
                                <OutlinedInput
                                  id={`discounts[${index}].rate`}
                                  name={`discounts[${index}].rate`}
                                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    console.log(event.target.value);
                                    setFieldValue(`discounts[${index}].rate`, event.target.value);
                                  }}
                                  placeholder="Discount Rate"
                                  type="number"
                                  endAdornment={<InputAdornment position="end">%</InputAdornment>}
                                />
                              </FormControl>
                            </Grid>
                            <Grid item xs={4}>
                              <IconButton size="small"
                                          onClick={() => discountsArrayHelpers.remove(index)}><CloseIcon/></IconButton>
                            </Grid>

                          </Grid>
                        )}
                        <Button style={{ width: 150 }} size="small" onClick={() => discountsArrayHelpers.push({
                          label: 'New Discount',
                          rate: 0
                        })}><AddIcon/> Add Discount</Button>

                      </Grid>
                    )}
                  </FieldArray>

                  <Button type="submit" color="secondary">Publish Discounts</Button>

                </Grid>
              </Form>
            )
          }
        </Formik>
        <Button color="secondary" onClick={() => setAdding(false)}>Cancel</Button>
      </Collapse>

    </Grid>
  );
}
